import React from 'react';
import Link from 'gatsby-link';
import './Menu.css';
import WhiteLizard from './assets/img/lezard_blanc.png';
import ComdeslezardsLogo from './assets/img/logo_comdeslezards.png';
import LinkedinLogo from './assets/img/linkedin_logo.png';
import TwitterLogo from './assets/img/twitter_logo.png';
import MessengerLogo from './assets/img/messenger_logo.png';

class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: false,
    };
  }

  open() {
    this.setState({ opened: true });
  }

  close() {
    this.setState({ opened: false });
  }

  render() {
    const { opened } = this.state;
    let menuIconClass = 'menu_icon';
    let menuClass = 'menu';
    let menuLinksClass = 'menu_links menu_hidden_part';
    let closeIcon = 'close_icon menu_hidden_part';
    let comdeslezardsLogoClass = 'menu_hidden_part';

    if (opened) {
      menuIconClass += ' menu_hidden_part';
      menuClass += ' menu_opened';
      menuLinksClass = 'menu_links';
      closeIcon = 'close_icon';
      comdeslezardsLogoClass = '';
    }

    return (
      <div className={menuClass}>
        <div className="top_bar">
          <div className="logo_containers">
            <Link to="/">
              <img
                className="lezard_top"
                src={WhiteLizard}
                alt="comdeslézards logo lézards blanc"
              />
            </Link>
            <Link to="/">
              <img className={comdeslezardsLogoClass} src={ComdeslezardsLogo} alt="logo comdeslézards com des lézards" />
            </Link>
          </div>
          <div
            className={closeIcon}
            onClick={e => this.close(e)}
            role="button"
            onKeyPress={e => this.close(e)}
            tabIndex={0}
          />
        </div>
        <div>
          <div
            className={menuIconClass}
            onClick={e => this.open(e)}
            role="button"
            onKeyPress={e => this.open(e)}
            tabIndex={0}
          />
          <ul className={menuLinksClass} onClick={e => this.close()}>
            <Link to="/">
              <li>
                accueil
              </li>
            </Link>
            <Link to="/sites-vitrine">
              <li>
                site vitrine
              </li>
            </Link>
            <Link to="/ecommerce">
              <li>
                ecommerce
              </li>
            </Link>
            <Link to="/applications-sur-mesure">
              <li>
                applications sur mesure
              </li>
            </Link>
            <Link to="/references">
              <li>
                références
              </li>
            </Link>
            <Link to="/blog">
              <li>
                blog
              </li>
            </Link>
            <Link to="/#contact">
              <li>
                contact
              </li>
            </Link>
            <Link to="/mentions-legales">
              <li>
                Mentions Légales
              </li>
            </Link>
          </ul>
        </div>
        <div className="social_container">
          <a href="https://www.linkedin.com/company/comdeslezards/" rel="nofollow">
            <img src={LinkedinLogo} alt="logo linkedin" />
          </a>
          <a href="https://twitter.com/comdeslezards" rel="nofollow">
            <img src={TwitterLogo} alt="logo twitter" />
          </a>
          <a href="https://www.facebook.com/comdeslezards/" rel="nofollow">
            <img src={MessengerLogo} alt="logo messenger" />
          </a>
        </div>
      </div>);
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.jsx